import { makeAutoObservable } from "mobx";

import { WhitelabelSettingReadModel } from "../../@api";

import { IWhiteLabelFiles } from "../models/interfaces/white-label-files.interface";

export class WhitelabelStore {
  private settings?: WhitelabelSettingReadModel[];

  private logo: Blob | undefined;

  public chatBotName = "smartChat";

  public files: IWhiteLabelFiles = {
    companyLogo: "company-logo.png",
    chatbotLogo: "chatbot-logo.png",
  };

  constructor() {
    makeAutoObservable(this);
  }

  public getWhiteLabelFileUrl(languageCode: string): string {
    return `/whitelabel-${languageCode}/`;
  }

  public get whitelabelSettings(): WhitelabelSettingReadModel[] | undefined {
    return this.settings;
  }

  public set whitelabelSettings(value: WhitelabelSettingReadModel[] | undefined) {
    this.settings = value;
  }

  public updateLogo(imageBlob: Blob): void {
    this.logo = imageBlob;
  }

  public get appLogo(): Blob | undefined {
    return this.logo;
  }
}
